import { Link, createFileRoute } from "@tanstack/react-router";
import HomeHero from "@/components/layout/HomeHero";
import PageContent from "@/components/PageContent";
import { Button } from "@/components/ui/button";
import { getDownloadUrl } from "@/lib/media";

export const Route = createFileRoute('/')({
  component: Home,
})

function Home() {
  return (
    <>
      <HomeHero />
      <PageContent>
        <div className="grid gap-x-18 gap-y-6 2xl:grid-cols-3">
          <section>
            <h2>
              About EVTCC
            </h2>
            <p className="text-justify md:block">
              The EVT Certification Commission, Inc. is a nonprofit corporation
              dedicated to improving the quality of emergency vehicle service
              and repair throughout the United States and Canada by means of a
              certification program that will provide technicians recognition
              for the education, training, and experience they have in the
              upfitting, service, and repair of emergency vehicles.
            </p>
            <Link to="/about">
              Learn more
            </Link>
          </section>
          <section>
            <h2>
              Upcoming Testing
            </h2>
            <p>Nationwide test dates are:</p>
            <ul>
              <li>Week of Saturday, June 12, 2027</li>
              <li>Week of Saturday, October 23, 2027</li>
            </ul>
            <p>
              Additional testing is available at Mechanic and Manufacturer
              Training events.
            </p>
            <ul>
              <li>
                <Link to="/testing-events">
                  Locate test events by state/province
                </Link>
              </li>
              <li>
                <a href={getDownloadUrl("EVTCC-Test-Site-List.pdf")}>
                  Download a list of testing events
                </a>
              </li>
            </ul>
          </section>
          <section>
            <h2>
              Registration
            </h2>
            <p className="text-justify">
              Online registration must be completed 16 days prior to testing.
              Save 10% by registering online.
            </p>
            <div className="my-8">
              <Button asChild size="lg" className="rounded-full border border-themered px-6 py-5 text-base font-bold text-themered bg-transparent hover:border-darkred hover:bg-linear-to-r hover:from-themered hover:to-darkred hover:text-white transition-all duration-300">
                <a
                  href="https://register.evtcc.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="no-underline hover:no-underline"
                >
                  &#9733; Register Online
                  <span className="sr-only"> (opens in a new tab)</span>
                </a>
              </Button>
            </div>
            <p className="text-justify">
              Paper registration forms must be <em>received</em> (fax, mail, or
              email) 21 days prior to the test date.
            </p>
            <a href={getDownloadUrl("EVTCC-Exam-Registration.pdf")}>
              Download the EVT Exam Registration Form
            </a>
          </section>
        </div>
      </PageContent>
    </>
  );
}
